import Tabbar from './tabbar.vue'
export default Tabbar



// WEBPACK FOOTER //
// ./src/components/tabbar/index.js